export enum Classes {
  ICON = "cs-icon",
  APP_ICON = "cs-app-icon",
  TEXT = "cs-text",
  BP3_POPOVER_ARROW_BORDER = "bp3-popover-arrow-border",
  BP3_POPOVER_ARROW_FILL = "bp3-popover-arrow-fill",
  SPINNER = "cs-spinner",
  MULTI_SELECT_BOX = "cs-multi-select-box",
  DATE_PICKER_OVARLAY = "date-picker-overlay",
}

export const replayHighlightClass = "ur--has-border";
